enum EVolumetricLayerDispense {
  Manual,
  Robot,
}

export default EVolumetricLayerDispense;
